export default function setIcons() {
  const icons = document.querySelectorAll('[data-swiper-icon]');

  if(icons.length > 0) icons.forEach(icon => {
    const pagination = icon.querySelector('.swiper-pagination');

    new Swiper(icon, {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        preloadImages: false,
        speed: 1000,
        lazy: {
            checkInView: true,
            loadPrevNext: false,
            loadOnTransitionStart: true,
        },
        pagination: {
          el: pagination,
          clickable: true,
        },
        breakpoints: {
          991: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
    });
  });
}
